var _path, _mask, _path2, _path3, _mask2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIconDarkFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "black"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_1286_14030",
    maskUnits: "userSpaceOnUse",
    x: 8.55469,
    y: 6.10938,
    width: 3,
    height: 11,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.55469,
    y: 6.10938,
    width: 3,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 7.55382C10.4436 7.30836 10.2446 7.10938 9.99913 7.10938C9.75367 7.10938 9.55469 7.30836 9.55469 7.55382V15.776C9.55469 16.0215 9.75367 16.2205 9.99913 16.2205C10.2446 16.2205 10.4436 16.0215 10.4436 15.776V7.55382Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 7.55382C10.4436 7.30836 10.2446 7.10938 9.99913 7.10938C9.75367 7.10938 9.55469 7.30836 9.55469 7.55382V15.776C9.55469 16.0215 9.75367 16.2205 9.99913 16.2205C10.2446 16.2205 10.4436 16.0215 10.4436 15.776V7.55382Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 7.55382C10.4436 7.30836 10.2446 7.10938 9.99913 7.10938C9.75367 7.10938 9.55469 7.30836 9.55469 7.55382V15.776C9.55469 16.0215 9.75367 16.2205 9.99913 16.2205C10.2446 16.2205 10.4436 16.0215 10.4436 15.776V7.55382Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-2-outside-1_1286_14030)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-2_1286_14030",
    maskUnits: "userSpaceOnUse",
    x: 8.55469,
    y: 3.22266,
    width: 3,
    height: 3,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8.55469,
    y: 3.22266,
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 4.6671C10.4436 4.42164 10.2446 4.22266 9.99913 4.22266C9.75367 4.22266 9.55469 4.42164 9.55469 4.6671V5.33377C9.55469 5.57923 9.75367 5.77821 9.99913 5.77821C10.2446 5.77821 10.4436 5.57923 10.4436 5.33377V4.6671Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 4.6671C10.4436 4.42164 10.2446 4.22266 9.99913 4.22266C9.75367 4.22266 9.55469 4.42164 9.55469 4.6671V5.33377C9.55469 5.57923 9.75367 5.77821 9.99913 5.77821C10.2446 5.77821 10.4436 5.57923 10.4436 5.33377V4.6671Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4436 4.6671C10.4436 4.42164 10.2446 4.22266 9.99913 4.22266C9.75367 4.22266 9.55469 4.42164 9.55469 4.6671V5.33377C9.55469 5.57923 9.75367 5.77821 9.99913 5.77821C10.2446 5.77821 10.4436 5.57923 10.4436 5.33377V4.6671Z",
    stroke: "white",
    strokeWidth: 0.6,
    mask: "url(#path-3-outside-2_1286_14030)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIconDarkFilled);
export default __webpack_public_path__ + "static/media/tooltip-icon-dark-filled.6e82a764ceb08823e2fadc8188787b89.svg";
export { ForwardRef as ReactComponent };